import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

export function getBoxes(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllBoxes(env))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_BOXES`,
                        boxes: data.boxes,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getBoxes - ', error);
                throw error;
            });
    };
}
export function getBoxDetails(env, macAddress) {
    return dispatch => {
        return apiCaller
            .call(api.getBoxDetails(env, macAddress))
            .then(({ data }) => {
                if (data.box && data.boxMac) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_BOX`,
                        boxMac: data.boxMac,
                        box: data.box,
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getBoxDetails - ', error);
                throw error;
            });
    };
}

export function updateBoxDetails(env, boxMac, boxForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateBoxDetails(env, boxMac, boxForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_BOX`,
                        boxMac: data.boxMac,
                        box: data.box,
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateBoxDetails - ', error);
                throw error;
            });
    };
}
export function homeDelete(env, homeId, boxId, boxMac) {
    return dispatch => {
        return apiCaller
            .call(api.homeDelete(env, homeId, boxId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__DELETE_HOME`,
                        payload: {
                            homeId,
                        },
                    });

                    if (boxMac) {
                        dispatch({
                            type: `${env.toUpperCase()}__UPDATE_BOX_STATE`,
                            payload: {
                                boxMac,
                            },
                        });
                    }
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: homeDelete - ', error);
                throw error;
            });
    };
}
export function updateBox(env, macAddress) {
    return () => {
        return getSocketMiddlewareInstance()
            .updateBox(macAddress)
            .catch(error => {
                Logger.log('dataActions: updateBox - ', error);
                throw error;
            });
    };
}

export function restartBox(env, macAddress) {
    return () => {
        return getSocketMiddlewareInstance()
            .restartBox(macAddress)
            .catch(error => {
                Logger.log('dataActions: restartBox - ', error);
                throw error;
            });
    };
}

export function startVpn(env, macAddress) {
    return () => {
        return getSocketMiddlewareInstance()
            .startVpn(macAddress)
            .catch(error => {
                Logger.log('dataActions: startVpn - ', error);
                throw error;
            });
    };
}

export function stopVpn(env, macAddress) {
    return () => {
        return getSocketMiddlewareInstance()
            .stopVpn(macAddress)
            .catch(error => {
                Logger.log('dataActions: stopVpn - ', error);
                throw error;
            });
    };
}

export function enableZway(env, macAddress) {
    return () => {
        return getSocketMiddlewareInstance()
            .enableZway(macAddress)
            .catch(error => {
                Logger.log('dataActions: enableZway - ', error);
                throw error;
            });
    };
}

export function disableZway(env, macAddress) {
    return () => {
        return getSocketMiddlewareInstance()
            .disableZway(macAddress)
            .catch(error => {
                Logger.log('dataActions: disableZway - ', error);
                throw error;
            });
    };
}

export function autocompleteBoxMac(env, macAddr) {
    return () => {
        return apiCaller
            .call(api.autocompleteBoxMac(env, macAddr))
            .then(({ data }) => {
                return data.boxes;
            })
            .catch(error => {
                Logger.log('dataActions: autocompleteBoxMac - ', error);
                throw error;
            });
    };
}
export function associateBox(env, macAddress, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.associateBox(env, macAddress, homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_BOX`,
                        boxMac: data.boxMac,
                        box: data.box,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: associateBox - ', error);
                throw error;
            });
    };
}

export function dissociateBox(env, macAddress, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.dissociateBox(env, macAddress, homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_BOX`,
                        boxMac: data.boxMac,
                        box: data.box,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: dissociateBox - ', error);
                throw error;
            });
    };
}
export function logClientInterfaceConnection(env, homeId) {
    return () => {
        apiCaller.call(api.logClientInterfaceConnection(env, homeId)).catch(error => {
            Logger.log('dataActions: logClientInterface - ', error);
            throw error;
        });
    };
}
export function getClientToken(env, homeId) {
    return () => {
        return apiCaller
            .call(api.getClientToken(env, homeId))
            .then(res => {
                return res;
            })
            .catch(error => {
                Logger.log('dataActions: getClientToken - ', error);
                throw error;
            });
    };
}
export function refreshBox(env, macAddress) {
    return () => {
        return getSocketMiddlewareInstance()
            .refreshBox(macAddress)
            .catch(error => {
                Logger.log('dataActions: refreshBox - ', error);
                throw error;
            });
    };
}

export function deleteConfigOverride(env, macAddress) {
    return dispatch => {
        return getSocketMiddlewareInstance()
            .deleteConfigOverride(macAddress)
            .then(() => {
                dispatch({
                    type: `${env.toUpperCase()}__UPDATE_BOX_CONFIG_OVERRIDE`,
                    macAddress,
                    config: null,
                });
            })
            .catch(error => {
                Logger.log('dataActions: deleteConfigOverride - ', error.message);
                throw error;
            });
    };
}

export function changeUpgradeStatus(env, macAddress, action) {
    return dispatch => {
        return getSocketMiddlewareInstance()
            .changeUpgradeStatus(macAddress, action)
            .then(() => {
                const upgrade = action === 'disable' ? 0 : 1;
                dispatch({
                    type: `${env.toUpperCase()}__UPDATE_BOX_UPGRADE`,
                    macAddress,
                    upgrade,
                });
            })
            .catch(error => {
                Logger.log('dataActions: changeUpgrade - ', error.message);
                throw error;
            });
    };
}

export function boxSwap(env, { mac, newMac, ...swapData }) {
    return dispatch => {
        return apiCaller
            .call(api.boxSwap(env, swapData))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SWAP_BOX`,
                        payload: { homeId: swapData.homeId, mac, newMac },
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: swapBox - ', error);
                throw error;
            });
    };
}

export function configureTendaRouter(env, macAddress, boxId) {
    return () => {
        return getSocketMiddlewareInstance()
            .configureTendaRouter(macAddress, boxId)
            .catch(error => {
                Logger.log('dataActions: startVpn - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Boxes/actions.js